import ActionButton from "../Button/ActionButton";
import CancelButton from "../Button/CancelButton";
import * as S from "./style";
// icons
import { Warning } from "@phosphor-icons/react";
// hooks
import apiRequest from "../../hooks/apiRequest";
import useLoading from "../../hooks/useLoading";

interface ModalDetailsProps {
  isOpenModal: boolean;
  setModalClose: () => void;
  selectedProductId: number | null;
  endpoint: string;
  updateList: () => void;
}

export default function Delete({
  isOpenModal,
  setModalClose,
  selectedProductId,
  endpoint,
  updateList,
}: ModalDetailsProps) {
  const { isLoading, startLoading, stopLoading } = useLoading();

  const handleRightButtonClick = async () => {
    startLoading();
    try {
      const response = await apiRequest(`${endpoint}/${selectedProductId}`, 'DELETE');
      if (response.status === 204) {
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.error ||
        error.mensage ||
        "Erro desconhecido.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModal) {
    return (
      <S.Container>
        <S.Content>
          <S.InfoModel>
            <Warning size={48} weight="fill" />
            <div>
              <h4>Tem certeza que deseja excluir este item?</h4>
              <p>Esta ação não poderá ser desfeita.</p>
            </div>
          </S.InfoModel>

          <S.Action>
            <CancelButton name="Cancelar" onClick={setModalClose} />
            <ActionButton
              disable={isLoading}
              name={isLoading ? "Excluindo..." : "Confirmar"}
              onClick={handleRightButtonClick}
            />
          </S.Action>
        </S.Content>
      </S.Container>
    );
  }
  return null;
}
